import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-grid-system';
import { useFieldArray, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';

import _ from 'lodash';
import axios from 'axios';

import { EVENT } from '../../globals';

import formatPdfFileName from '../_libs/utils/formatPdfFileName';

import { useApp } from '../_libs/hooks/useApp';
import { useBrand } from '../_libs/hooks/useBrand';
import { useData } from '../_libs/hooks/useData';
import { usePdfUrl } from '../_libs/hooks/usePdfUrl';

import EmailContactInputs from '../molecules/EmailContactInputs';

const ShareForm = (): JSX.Element => {
  const { pdfUrl, pdfBlob } = usePdfUrl();
  const {
    radius,
    reportData,
    userId,
    zipCode,
  } = useApp();
  const {
    primaryBrand,
    coBrand,
  } = useBrand();
  const {
    reportData: agData,
    topThemes,
  } = useData();
  const {
    control,
    handleSubmit,
    setValue,
  } = useForm();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'contacts'
  });
  const [shouldShowForm, toggleShouldShowForm] = useState(false);

  // Add one field on component mount
  useEffect(() => {
    append({
      name: '',
      email: '',
    });
  }, []);

  const onSubmit = (data) => {
    // TODO: Validate email addresses

    const subject = `${primaryBrand.name}'s radian™ Health Equity Toolkit for the ${radius}-mile area around ${zipCode}`;
    const body = `Hello there,

Thank you for your time discussing Lightbeam's Health Equity AI offerings. Through Clinical & Health Equity AI, Deviceless RPM, and industry-leading cohort creation & analytics, Lightbeam is proud to bring cutting-edge solutions to the most innovative healthcare organizations and the individuals they serve.

The 'Health Equity Strategy in a Box,' generated for ${primaryBrand.name}, is ready to view and download.

Estimated Population: ${Intl.NumberFormat('en-US').format(agData.totalpopulation_est)}
Estimated Households: ${Intl.NumberFormat('en-US').format(agData.household_est)}
Block Groups: ${Intl.NumberFormat('en-US').format(agData.count)}
Health Equity AI-Informed Themes: ${topThemes.length}

Access your PDF report by following this link: ${pdfUrl}.

Thank you,

`;
    let _mailToLink = 'mailto:';
    let emails = '';
    let contacts = '';
    let emailCount = 0;
    _.each(data.contacts, (fields) => {
      const _name = fields.name.trim();
      const _email = fields.email.trim();
      if (emailCount > 0) {
        emails += ',';
        contacts += ';';
      } 
      if (_name.length !== 0 && _email.length !== 0) {
        emails += `${_email}`;
        contacts += `${_name}<${_email}>`;
      } else {
        if (_name.length === 0) {
          // Throw error about empty name
        }
        if (_email.length === 0) {
          // Throw error about empty email
        }
      }
      emailCount++;
    });
    axios.post('/create_event/', {
      organizationId: primaryBrand.id,
      coBrandId: coBrand.id,
      reportId: reportData.id,
      userId,
      eventCode: EVENT.EmailReport,
      key: 'emails',
      value: contacts,
    });
    _mailToLink += encodeURIComponent(emails);
    _mailToLink += `?subject=${encodeURIComponent(subject)}`;
    _mailToLink += `&body=${encodeURIComponent(body)}`;
    window.location.href = _mailToLink;
  };

  function handlePDFDownload () {
    // TODO: move useEvent()
    axios
      .post('/create_event/', {
        reportId: reportData.id,
        organizationId: primaryBrand.id,
        coBrandId: coBrand.id,
        userId,
        eventCode: EVENT.DownloadReport,
      });
  }

  function handleReturnToDashboard () {
    // TODO: move useEvent()
    axios
      .post('/create_event/', {
        organizationId: primaryBrand.id,
        coBrandId: coBrand.id,
        reportId: reportData.id,
        userId,
        eventCode: EVENT.UIReturnToDashboard,
      });
  }

  const handleAdd = () => {
    append({
      name: '',
      email: '',
    });
  };

  // TODO: Automatically set focus on newest name field
  // useEffect(() => {
  //   if (fields.length > 0) {
  //     setFocus(`contacts.${fields.length - 1}.name`, {
  //       shouldSelect: true,
  //     });
  //   } 
  // }, [fields]);

  const fileName = formatPdfFileName(primaryBrand.name, radius, zipCode);

  return (
    pdfUrl &&
      <div className="mt-4">
        <Row>
          <Col>
            <button type="button" onClick={handlePDFDownload}>
              <a className="td-none" href={URL.createObjectURL(pdfBlob)} download={fileName}>Download PDF</a>
            </button>
            <button type="button" className="button ml-2" onClick={() => { toggleShouldShowForm(!shouldShowForm); }}>Share PDF</button>
          </Col>
          <Col style={{
            textAlign: 'right',
          }}>
            <Link className="button td-none inline-block f-sans" onClick={handleReturnToDashboard} to={'/dashboard/'} replace={false}>Return to {primaryBrand.name}‘s Dashboard</Link>
          </Col>
        </Row>
        <form
          style={{
            display: shouldShowForm ? 'block' : 'none',
          }}
          onSubmit={handleSubmit(onSubmit)}>
          <h2 className="f-sans mt-0">Share PDF Form</h2>
          {
            fields.map((field, index) => {
              return (
                <EmailContactInputs
                  key={field.id}
                  count={fields.length}
                  index={index}
                  remove={remove}
                  setValue={setValue} />
              );
            })
          }
          <Row align="center" className="mb-4">
            <Col sm={5}>
              <button type="button" className="bare" onClick={handleAdd}>Add Email</button>
            </Col>
            <Col sm={5}>
              <button className="bg-white" type="submit" disabled={!pdfUrl}>{ (!pdfUrl) ? 'Loading PDF...' : 'Share PDF' }</button>
            </Col>
          </Row>
        </form>
      </div>
  );
};

export default ShareForm;
